
import { req, reqJson, reqGet } from './axiosFun';

//获取验证码图片base64
export const getCode = (params) => { return req("get", "/user/getImgCode", params) };
//查询所有文章列表
export const getArticleList = (params) => { return reqJson("post", "/article/where", params) };
//查询公司
export const getCompanyList = (params) => { return req("get", "/home/kingname", params) };
//新增公司
export const addCompanyList = (params) => { return reqJson("post", "/home/kingname", params) };
//修改公司
export const editCompanyList = (params) => { return reqJson("put", "/home/kingname", params) };
//删除公司
export const delCompanyList = (params) => { return reqJson("delete", "/home/kingname", params) };


// 获取上海太保数据列表
export const getTbArticleList = (params) => { return reqJson("get", "/TaiBaoNews?id=", params) };
// 新增上海太保数据列表
export const addTbArticleList = (params) => { return reqJson("post", "/TaiBaoNews", params) };
// 编辑上海太保数据列表
export const editTbArticleList = (params) => { return reqJson("put", "/TaiBaoNews", params) };
// 删除上海太保数据列表
export const delTbArticleList = (params) => { return reqJson("delete", "/TaiBaoNews", params) };

    
//查询轮播图
export const getBannerList = (params) => { return reqJson("post", "/banner/selectKingBanner", params) };
//新增轮播图
export const addBanner = (params) => { return reqJson("post", "/banner/create", params) };
//修改轮播图
export const updateBanner = (params) => { return reqJson("post", "/banner/update", params) };
//删除轮播图
export const delBanner = (params) => { return reqJson("post", "/banner/delete?id=" + params) };


//条件查询
// export const addArticle = (params) => { return reqJson("post", "/article", params) };
//新增文章
export const addArticle = (params) => { return req("post", "/article", params) };
//编辑文章
export const editArticle = (params) => { return reqJson("put", "/article", params) };
//删除文章
export const delArticle = (params) => { return reqJson("delete", "/article", params) };



//获取留言板列表
export const getMessageboard = (params) => { return reqJson("post", "/home/msg/query", params) };
//删除留言板列表
export const delMessageboard = (params) => { return reqJson("delete", "/home/msg", params) };

// //获取公司列表
// export const getCompanyList = (params) => { return req("get", "/home/msg", params) };


// WEBPACK FOOTER //
// ./src/api/newApis.js